// ============================================
// LAYOUT - Root Layout (Wrapper con PageTracker)
// ============================================

import { Outlet } from 'react-router-dom';
import { PageTracker } from '../components/PageTracker';

/**
 * Layout raíz que envuelve toda la aplicación
 * Incluye el PageTracker para GTM en todas las rutas
 */
export const RootLayout = () => {
  return (
    <>
      <PageTracker />
      <Outlet />
    </>
  );
};
